import React, { useState, useEffect } from 'react'
import Modal from "react-bootstrap/Modal";
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { useForm } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.min.css";

const EditModal = ({ show, onClose, row, degrees, updateDegree }) => {
  // const defaultValues = {};
  const { register, handleSubmit, watch, formState: { errors }, unregister, reset } = useForm({ shouldUnregister: true });
  const [degree, setDegree] = useState({});
  useEffect(() => {
    if (show) {
      setDegree(row);
      reset(row);
    }
  }, [show]);
  const onSubmit = data => {
    data._id = row._id;
    delete data.duration;
    updateDegree(data);
  }
  return (
    <>
      <Modal show={show} onHide={() => onClose()} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Degree details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group className="mb-3" controlId="degree">
              <Form.Label>Degree name</Form.Label>
              <Form.Control type="text" defaultValue={degree.name} {...register("name")} placeholder="Enter degree name" />
              <Form.Text className="text-muted">
                Write short only forms eg: BTech
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-3" controlId="years">
              <Form.Label>No.of years</Form.Label>
              <Form.Control disabled type="number" defaultValue={degree.duration} {...register("duration")} placeholder="Duration of degree" />
            </Form.Group>
            <div className='d-flex justify-content-center'>
            <Button className="saveBtn" type="submit">
              Save
            </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default EditModal



